import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新しい提出物を作成")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_5 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_6 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_7 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_8 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "useManagement",
  class: "pl-2 cursor-pointer"
}, " 締切日設定・提出管理機能を使う ", -1)
const _hoisted_11 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_12 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_13 = {
  key: 2,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "通知設定", -1)
const _hoisted_15 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", {
  for: "willSendMessageForUnsubmitted",
  class: "pl-2 cursor-pointer"
}, " 未提出の生徒への通知を送信 ", -1)
const _hoisted_18 = {
  key: 0,
  class: "mt-2 text-red-500 text-sm"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 提出物を登録 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_ms_student_picker = _resolveComponent("ms-student-picker")
  const _component_m_text_area = _resolveComponent("m-text-area")
  const _component_m_link_list = _resolveComponent("m-link-list")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "提出物名",
          name: "name",
          type: "text",
          placeholder: "提出物名を入力",
          invalid: _ctx.isUniqueSubmissionMasterName,
          "invalid-message": "同じ名前の提出物が存在します。提出物名か先生管理用ラベルを変更してください。",
          value: _ctx.name,
          entered: _ctx.enteredName,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
          onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enteredName = true))
        }, null, 8, ["invalid", "value", "entered"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_text_field, {
          label: "先生管理用ラベル（生徒には見えず、提出物名の後に表示されます）「提出物名」_「ラベル」",
          name: "label",
          type: "text",
          placeholder: "ラベルを入力",
          invalid: _ctx.isUniqueSubmissionMasterName,
          "invalid-message": "同じ名前の提出物が存在します。提出物名か先生管理用ラベルを変更してください。",
          value: _ctx.label,
          entered: _ctx.enteredLabel,
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.label = $event)),
          onEnter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.enteredLabel = true))
        }, null, 8, ["invalid", "value", "entered"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ms_student_picker, {
          defaultStudentIds: [],
          onUpdate: _ctx.onStudentsUpdated
        }, null, 8, ["onUpdate"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_m_text_field, {
          label: "表示開始日",
          name: "submittableDate",
          type: "date",
          placeholder: "表示開始日を入力",
          "data-is-invalid": 
            (_ctx.useManagement && _ctx.closedAt <= _ctx.submittableFrom) ||
            (!_ctx.useManagement && _ctx.displayEndAt <= _ctx.submittableFrom)
          ,
          invalid: 
            (_ctx.useManagement && _ctx.closedAt <= _ctx.submittableFrom) ||
            (!_ctx.useManagement && _ctx.displayEndAt <= _ctx.submittableFrom)
          ,
          "invalid-message": 
            _ctx.useManagement
              ? '表示開始日には締切日よりも過去の日付を設定してください'
              : '表示開始日には表示終了日よりも過去の日付を設定してください'
          ,
          value: _ctx.submittableDate,
          entered: true,
          onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submittableDate = $event))
        }, null, 8, ["data-is-invalid", "invalid", "invalid-message", "value"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_m_text_field, {
          label: "表示終了日（入力された日付から生徒画面上に表示されなくなります）",
          name: "displayEndAt",
          type: "date",
          placeholder: "表示終了日を入力",
          invalid: 
            (_ctx.useManagement && _ctx.displayEndAt <= _ctx.closedAt) ||
            (!_ctx.useManagement && _ctx.displayEndAt <= _ctx.submittableFrom)
          ,
          "invalid-message": 
            _ctx.useManagement
              ? '表示終了日には締切日よりも未来の日付を設定してください'
              : '表示終了日には表示開始日よりも未来の日付を設定してください'
          ,
          value: _ctx.displayEndDate,
          entered: true,
          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.displayEndDate = $event))
        }, null, 8, ["invalid", "invalid-message", "value"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_m_text_area, {
          label: "説明文",
          name: "description",
          type: "text",
          placeholder: "生徒向けの説明文を入力",
          value: _ctx.description,
          entered: true,
          onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.description = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode(_component_m_link_list, {
        class: "w-3/4 mx-auto mb-6",
        links: _ctx.relatedLinks,
        onUpdate: _ctx.onUpdateRelatedLinks
      }, null, 8, ["links", "onUpdate"]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _withDirectives(_createVNode("input", {
            id: "useManagement",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.useManagement = $event)),
            type: "checkbox",
            name: "useManagement",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 512), [
            [_vModelCheckbox, _ctx.useManagement]
          ]),
          _hoisted_10
        ])
      ]),
      (_ctx.useManagement)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode(_component_m_text_field, {
              label: "締切日 ※",
              name: "closedDate",
              type: "date",
              placeholder: "締切日を入力",
              invalid: _ctx.useManagement && _ctx.closedAt <= _ctx.now,
              "invalid-message": "締切日には未来の日付を設定してください",
              value: _ctx.closedDate,
              entered: true,
              onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closedDate = $event))
            }, null, 8, ["invalid", "value"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.useManagement)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode(_component_m_text_field, {
              label: "締切時間 ※",
              name: "closedTime",
              type: "time",
              placeholder: "締切時間を入力",
              value: _ctx.closedTime,
              onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closedTime = $event))
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.useManagement)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _hoisted_14,
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _withDirectives(_createVNode("input", {
                  id: "willSendMessageForUnsubmitted",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.willSendMessageForUnsubmitted = $event)),
                  type: "checkbox",
                  name: "willSendMessageForUnsubmitted",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.willSendMessageForUnsubmitted]
                ]),
                _hoisted_17
              ]),
              (_ctx.willSendMessageForUnsubmitted)
                ? (_openBlock(), _createBlock("div", _hoisted_18, " ※ 毎日 7 時と 16 時に、締切が近い・締切を過ぎていて未提出の生徒に対してメッセージが送信されます。 "))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.createSubmission
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}